export default __webpack_public_path__ + "static/media/defaultUser.b18431ad.svg";